/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RelationalTariffProfileDto = {
    /**
     * Tariff profile type.
     */
    type: RelationalTariffProfileDto.type;
    /**
     * Day validity.
     */
    dayValidity?: number;
    /**
     * Floating time validity.
     */
    floatingTimeValidity: boolean;
    /**
     * Date from which the entity is valid.
     */
    validFrom: string;
    /**
     * Tariff profile identifier. Type: 'UUID'
     */
    id: string;
    /**
     * Tariff profile number.
     */
    profileNumber: number;
    /**
     * Tariff profile name.
     */
    name?: string;
};
export namespace RelationalTariffProfileDto {
    /**
     * Tariff profile type.
     */
    export enum type {
        COUPON = 'COUPON',
        SINGLE = 'SINGLE',
    }
}

